import { useParams } from 'react-router-dom';
import { ClientDeliveryCustomerConfirmation } from './ClientDeliveryCustomerConfirmation';

export const ClientDeliveryCustomerConfirmationContainer = () => {
  const params = useParams<{ token: string }>();

  return <ClientDeliveryCustomerConfirmation token={params.token} />;
};
